<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Despacho de Embarcacion {{ titleDispatch }}</h3>
            <h6 clas="col" align="center">UFV {{ ufv }} al {{ date_ufv }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button> </h6>
            <h6 clas="col" align="right"><b>C:</b> {{ cut.toFixed(5) }} <b>A:</b> {{ actividad.factor > 0 ? actividad.factor:0}} <b>P:</b> {{ boatLocal.factor_propulsion ? boatLocal.factor_propulsion : propulsion.factor }} <b>N:</b> {{ navegacion_sub.factor > 0 ? navegacion_sub.factor:0}} <b>AN:</b> {{ helpNavigate.factor ? helpNavigate.factor : 0 }} </h6>

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one ? 'active':'']" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">2. Operacion</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">3. Carga</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_fourth ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false">4. Resumen</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                
                <div class="tab-pane fade" :class="[is_active_step_one ? 'show active':'']" id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.name_boat" id="enrollment_boat" placeholder="Nombre Embarcacion" :readonly="is_disabled ? true:false " autocomplete="off">
                        </div>
                        
                        <div class="form-group col-12 col-md-6">
                            <label for="matricula" class="badge badge-primary">Matricula de la Embarcacion</label>
                            <input v-if="boatLocal.enrollment" type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.enrollment" name="matricula" placeholder="Matricula Embarcacion" autocomplete="off">
                            <input v-else-if="boatLocal.enrollment_old" type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.enrollment_old" name="matricula" placeholder="Matricula Embarcacion" autocomplete="off">
                            <input v-else type="text" class="form-control" :disabled="global_disabled ? true:false" v-model="boatLocal.enrollment" name="matricula" placeholder="Matricula Embarcacion" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcacion</label>
                            <input type="text" class="form-control" name="flag_ship" v-model="boatLocal.flag_boat" v-if="boatLocal.flag_boat" :readonly="global_disabled ? true:false ">
                            <select v-else class="form-control" name="bandera_embarcacion" v-model="bandera">
                                <option v-for="flag in banderas" :value="flag" :key="flag.id">{{ flag.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="propulsion" class="badge badge-primary">Propulsion</label>
                            <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-if="boatLocal.detail_propulsion" v-model="boatLocal.detail_propulsion">
                            <select v-else class="form-control" v-model="propulsion" name="propulsion" @change="calculateForm">
                                <option v-for="motor in propulsiones" :key="motor.id" :value="motor">{{ motor.detail }}</option>
                            </select>

                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo nave</label>
                                <input type="text" class="form-control" :disabled="global_disabled ? true:false" v-if="boatLocal.detail_boat" v-model="boatLocal.detail_boat">
                                <select v-else class="form-control" v-model="type_boat" name="propulsion">
                                    <option v-for="boat in types_boat" :key="boat.id" :value="boat.detail">{{ boat.detail }}</option>
                                </select>
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" v-model="boatLocal.trb" :disabled="global_disabled ? true:false" class="form-control" name="trb" placeholder="TRB" @keyup="calculateForm" autocomplete="off">
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label for="trb" class="badge badge-primary">TRN</label>
                            <input type="number" v-model="boatLocal.trn" :disabled="global_disabled ? true:false" class="form-control" name="trb" placeholder="TRN" autocomplete="off">
                        </div>
                    </div>                    

                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end first tab traffic -->

                <div class="tab-pane fade" :class="[is_active_step_two ? 'show active':'']" id="nav-second" role="tabpanel" aria-labelledby="nav-profile-tab">
                    

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="captain" class="badge badge-primary">Capitan de la nave</label>
                            <input type="text" class="form-control" autocomplete="off" v-model="capitan_ship" placeholder="Capitan de la Nave">
                            
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="tipo_navegacion" class="badge badge-primary">Despacho de Nave</label>
                            <select class="form-control" v-model="navegacion" name="tipo_navegacion" @change="callNavDet">
                                <option v-for="navigate in navegaciones" :value="navigate" :key="navigate.id">{{ navigate.detail }} </option>
                            </select>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                    <div v-if="state_navigation_sub">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="navegacion_detalle" class="badge badge-info">Tipo de Navegacion</label>
                                <select class="form-control" v-model="navegacion_sub" name="navegacion_detalle" @change="calculateForm">
                                    <option v-for="n_detail in navegaciones_sub" :key="n_detail.id" :value="n_detail" >{{ n_detail.detail }}</option>
                                </select>
                            </div>
                                    
                            <div class="form-group col-12 col-md-6">
                                <label for="fecha_despacho" class="badge badge-info">Fecha de {{ type_navigate }}</label>
                                <datetime v-model="date_office" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                <!-- <input type="date" class="form-control" v-model="date_office" name="fecha_despacho" placeholder="Fecha" autocomplete="off"> -->
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="puerto_origen" class="badge badge-info">Puerto de Origen</label>
                                <select v-if="port_begin.disabled" name="port_begin_select" class="form-control" v-model="port_select_begin">
                                    <option v-for="p in ports_registers_captain" :key="p.id" :value="p">{{ p.description }}</option>
                                </select>

                                <vue-bootstrap-typeahead                                        
                                        v-model="port_query"
                                        :data="portsRegister"
                                        :serializer="item => item.portDetail"
                                        @hit="mSelectedPort"
                                        :placeholder="placeholder_port"
                                        v-else
                                    />
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="puerto_destino" class="badge badge-info">Puerto de Destino</label>
                                <select v-if="port_finish.disabled" name="port_begin_select" class="form-control" v-model="port_select_finish">
                                    <option v-for="p in ports_registers_captain" :key="p.id" :value="p">{{ p.description }}</option>
                                </select>
                                <vue-bootstrap-typeahead                                        
                                        v-model="port_query"
                                        :data="portsRegister"
                                        :serializer="item => item.portDetail"
                                        @hit="mSelectedPort"
                                        :placeholder="placeholder_port"
                                        v-else
                                    />
                            </div>
                        </div>
                    </div>
                    </transition>
                    
                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-warning col-6 col-md-4" @click="fNext">
                            <font-awesome-icon icon="chevron-circle-right" size="lg" />
                        </button>
                    </div>
                </div>
                <!-- end second tab -->

            <div class="tab-pane fade" :class="[is_active_step_tree ? 'show active':'']" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_load" class="badge badge-primary">Detalle Carga o Servicio Principal</label>
                            <vue-bootstrap-typeahead                                        
                                        v-model="load_query"
                                        :data="loads_type"
                                        :serializer="item => item.carga_detail"
                                        @hit="mSelectLoad"
                                        :placeholder="dPlaceLoad"
                                    />
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="actividad" class="badge badge-primary">Tipo de servicio</label>
                                <input class="form-control" type="text" disabled="disabled" v-model="aux_activity.service" />
                                <!-- <select class="form-control" v-model="actividad" name="actividad" @change="calculateForm">
                                    <option v-for="activity in actividades_nave" :key="activity.id" :value="activity">{{ activity.detail }}</option>
                                </select> -->
                        </div>
                </div>

                    <!-- <div class="form-row">
                        <div class="col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">Datos Adicionales de la carga</label><br>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" v-model="c_efectiva_load" @change="viewForm">
                                <label class="form-check-label" for="inlineCheckbox1">Carga</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" v-model="c_efectiva_passenger" @change="viewForm">
                                <label class="form-check-label" for="inlineCheckbox2">Pasajeros</label>
                            </div>
                        </div>
                    </div>               -->
                        <transition name="fade" mode="out-in">
                        <div v-if="c_efectiva_passenger">
                            <h6><span class="badge badge-primary">Cantidad Pasajeros</span></h6>
                            <div class="row">
                            <div class="col-12 col-md-6">
                                <h6><span class="badge badge-success">Bolivianos</span></h6>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                    </div>
                                    <input type="number" v-model="national_men" class="form-control" aria-label="Default" placeholder="0" aria-describedby="inputGroup-sizing-default">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                    </div>
                                    <input type="number" class="form-control" v-model="national_women" aria-label="Default" placeholder="0" aria-describedby="inputGroup-sizing-default">
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <h6><span class="badge badge-success">Extranjeros</span></h6>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                    </div>
                                    <input type="number" v-model="foreign_men" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="0">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                    </div>
                                    <input type="number" v-model="foreign_women" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="0">
                                </div>
                            </div>
                            </div>
                        </div>
                        </transition>
                        


                        <transition name="fade" mode="out-in">
                            <div v-if="c_efectiva_load_kilo">                  

                            <div class="form-row">
                                
                                <div class="form-group col-12 col-md-12">
                                    <div class="row">
                                        
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_kilo" class="badge badge-info">Kilos</label>
                                            <input type="number" v-model="load_cash_kilo" @keyup="calcKiloTonelada" class="form-control" aria-label="Default" placeholder="Kilos" aria-describedby="inputGroup-sizing-default">    
                                        </div>
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_tonelada" class="badge badge-info">Toneladas</label>
                                            <input type="number" v-model="load_cash_tonelada" @keyup="calcToneladaKilo" class="form-control" aria-label="Default" placeholder="Toneladas" aria-describedby="inputGroup-sizing-default">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-12 col-md-2">
                                            <label for="input_load" class="badge badge-info">Cantidad</label>
                                            <input type="number" min="0" class="form-control" autocomplete="off" v-model="c_quantity">
                                        </div>

                                        <div class="form-group col-12 col-md-4">
                                            <label for="input_load" class="badge badge-info">Unidad de carga</label>
                                            <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_unit_measurement" >
                                                <option v-for="tl in type_load_solid" :value="tl" :key="tl.id">{{tl.detail}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="input_load" class="badge badge-info">Descripcion de la Carga</label>
                                            <input type="text" class="form-control" v-model="description_charge" autocomplete="off">
                                        </div>
                                    </div>                                    
                                </div>

                                
                            </div>
                            
                            </div>
                        </transition>

                        <transition name="fade" mode="out-in">
                                    <div v-if="c_efectiva_load_rodada">

                                    <div class="form-row">
                                        <div class="form-group col-12 col-md-12">
                                        
                                        <div class="row">

                                            <div class="form-group col-12 col-md-3" >
                                                <label for="load_quantity" class="badge badge-info">Cantidad</label>
                                                <input type="number" v-model="c_quantity" class="form-control" placeholder="Cantidad" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                        
                                            <div class="form-group col-12 col-md-3">
                                                <label for="input_load" class="badge badge-info">Unidad de carga</label>
                                                <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_unit_measurement" >
                                                    <option v-for="tl in type_load_solid" :value="tl" :key="tl.id">{{tl.detail}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-12 col-md-6">
                                                <label for="input_load" class="badge badge-info">Descripcion de la Carga</label>
                                                <input type="text" class="form-control" v-model="description_charge" autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                                </transition>

                        <transition name="fade" mode="out-in">
                            <div v-if="c_efectiva_load_litro">                  

                            <div class="form-row">
                                <div class="form-group col-12 col-md-12">

                                <div class="row">

                                    <div class="form-group col-12 col-md-4">
                                        <label for="load_cash_kilo" class="badge badge-info">Liquido (litros)</label>
                                        <input type="number" v-model="load_cash_litro" class="form-control" placeholder="Litros" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                    </div>
                                </div>
                                <div class="row">
                                        <div class="form-group col-12 col-md-3">
                                            <label for="input_load" class="badge badge-info">Cantidad</label>
                                            <input type="number" min="0" class="form-control" v-model="c_quantity">
                                        </div>
                                        <div class="form-group col-12 col-md-3">
                                            <label for="input_load" class="badge badge-info">Unidad de carga</label>
                                            
                                            <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_unit_measurement" >
                                                <option v-for="tl in type_load_liquid" :value="tl" :key="tl.id" >{{tl.detail}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <label for="input_load" class="badge badge-info">Descripcion de la Carga</label>
                                            <input type="text" class="form-control" v-model="description_charge" autocomplete="off">
                                        </div>
                                </div>
                                </div>
                                </div>
                            </div>
                        </transition>

                        <transition name="fade" mmode="out-in">
                            <div v-if="is_dredge">
                                <div class="form-row">
                                    <div class="form-group col-12 col-md-4">
                                        <label for="load_cash_kilo" class="badge badge-danger">Dias de Trabajo</label>
                                        <input type="number" v-model="job_days" class="form-control" placeholder="Dias de Trabajo" aria-label="Default" aria-describedby="inputGroup-sizing-default" @change="calculateForm">
                                    </div>
                                    <div class="form-group col-12 col-md-3">
                                        <label for="date_init_ordop" class="badge badge-danger">Fecha Zarpe <span class="required-text">*</span></label>
                                        <datetime v-model="date_init_oper_aux" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                        <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                                    </div>
                                    <div class="form-group col-12 col-md-3">
                                        <label for="time_init_ordop" class="badge badge-danger">Fecha Arribo <span class="required-text">*</span></label>
                                        <datetime v-model="date_end_oper_aux" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                                        <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                                    </div>

                                </div>
                            </div>
                        </transition>

                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-warning col-6 col-md-4" @click="fNext">
                            <font-awesome-icon icon="chevron-circle-right" size="lg" />
                        </button>
                    </div>

            </div>
            <!-- end tirdth tab -->

            <div class="tab-pane fade" :class="[is_active_step_fourth ? 'show active':'']" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                <br>
                    <div class="form-row">
                        
                        <div class="col-md-4"></div>
                        <button class="btn btn-outline-success btn-sm col-6 col-md-2" value="si" @click="callRegisterPerson('T')"><font-awesome-icon icon="users" /> Tripulantes</button>
                        <button class="btn btn-outline-warning btn-sm col-6 col-md-2" value="si" @click="callRegisterPerson('P')"><font-awesome-icon icon="user" /> Pasajeros</button>
                        <button class="btn btn-outline-info btn-sm col-6 col-md-2" value="si" @click="callRegisterCharge"><font-awesome-icon icon="plus" /> Carga Secundarias</button>
                        <button class="btn btn-outline-dark btn-sm col-6 col-md-2" value="no" @click="callViewCharges"><font-awesome-icon icon="eye" /> Cargas Secundarias</button>
                    </div>
                    <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="actividad" class="badge badge-success">Nombre Embarcacion</label>
                                <p class="text-uppercase" v-if="boatLocal.name_boat">{{ boatLocal.name_boat }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="load_cash_kilo" class="badge badge-success">TRB</label>
                                <p class="text-uppercase" v-if="boatLocal.trb">{{ boatLocal.trb }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="load_cash_litro" class="badge badge-success">Propulsion</label>
                                <p class="text-uppercase" v-if="boatLocal.detail_propulsion">{{ boatLocal.detail_propulsion }}</p>
                                <p class="text-uppercase" v-else-if="propulsion.detail">{{ propulsion.detail }}</p>
                                <p class="text-uppercase" v-else>--Sin datos--</p>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="actividad" class="badge badge-success">Tipo Despacho</label>
                                <p class="text-uppercase" v-if="type_navigate">{{ type_navigate }}</p>
                                <p class="text-uppercase" v-else>--Sin Datos--</p>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="actividad" class="badge badge-success">Servicio</label>
                                <p class="text-uppercase" v-if="navegacion_sub">{{ navegacion_sub.detail }}</p>
                                <p class="text-uppercase" v-else>-- Sin datos --</p>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="actividad" class="badge badge-danger">Regimen Mercaderia</label>
                                <select name="type_aux_load" class="form-control" id="type_ordop" v-model="aux_mercancy" >
                                    <option v-for="mr in mercancy_regime" :value="mr.detail" :key="mr.id">{{mr.detail}}</option>
                                </select>
                            </div>

                        </div>

                    <div class="form-row" v-if="is_cabotaje">
                            <!-- aqui va la parte donde indicaran si existio inconvenientes respecto  -->
                        <div class="custom-control custom-switch">
                            <input type="checkbox" v-model="value_days_cabotaje.val" class="custom-control-input" id="customSwitch2" @change="mChangeSindicate">
                            <label class="custom-control-label" for="customSwitch2"><span :class="value_days_cabotaje.val ? 'alert-danger':'alert-success'">{{value_days_cabotaje.detail}}</span></label>
                        </div>
                    </div>
                    <div class="form-row" v-if="value_days_cabotaje.val">
                        <div class="form-group col-12 col-md-3">
                            <label for="dias_solicitados">Dias Solicitados</label>
                            <input type="number" v-model="value_cabotaje.days" class="form-control" autocomplete="off" @keyup="calculateForm">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="dias_solicitados">Descripcion del sindicato u asociacion</label>
                            <input type="text" v-model="value_cabotaje.description" class="form-control" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row" v-if="autImport==='S' && total_form > 0 " >
                        <button class="btn btn-outline-danger col-md-1 offset-md-5" @click="mEditImport('R')"><font-awesome-icon icon="minus-circle" /></button>           
                        <button class="btn btn-outline-danger col-md-1" @click="mEditImport('I')"><font-awesome-icon icon="plus" /></button>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-6 col-md-3 offset-md-3">
                            <label for="total_importe" class="badge badge-primary">Importe Individual Nave Principal Bs.</label>
                            <input type="text" class="form-control" name="total_importe" v-model="total_form" placeholder="TOTAL IMPORTE" disabled >
                        </div>
                        <div class="form-group col-6 col-md-3">
                            <label for="total_importe" class="badge badge-primary">Importe Total (Principal + Asociadas) Bs.</label>
                            <input type="text" class="form-control" name="total_importe" v-model="total_second" placeholder="TOTAL IMPORTE" disabled >
                        </div>
                        
                    </div>
                    
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cQuestionShip">
                        <span class="col-12">¿Antes de finalizar desea añadir mas Embarcaciones?  </span>                        
                        <button class="btn btn-outline-success btn-sm col-6 col-md-2 offset-md-4" value="si" @click="mAddShip">SI</button>
                        <button class="btn btn-outline-danger btn-sm col-6 col-md-2" value="no" @click="mAddShip">NO</button>
                    </div>
                    </transition>
                    <transition name="fade" mode="in-out">
                    <div class="form-row" v-if="cFormAddShip">                
                        <button class="btn btn-outline-info btn-sm col-6 col-md-3 offset-md-3" data-toggle="modal" data-target="#addBoat" @click="callRegister">
                            <font-awesome-icon icon="plus" size="lg" />Añadir Nave
                        </button>  
                        <button class="btn btn-outline-success btn-sm col-6 col-md-3" data-toggle="modal" data-target="#addBoat" @click="callViewBoats" >
                            <font-awesome-icon icon="eye" size="lg" />Naves Asociadas
                        </button>
                    </div>
                    </transition>
                    <br>
                    <div class="form-row">
                        <button class="btn btn-outline-danger col-6 col-md-4 offset-md-2" @click="fBack">
                            <font-awesome-icon icon="chevron-circle-left" size="lg" />
                        </button>
                        <button class="btn btn-outline-primary col-6 col-md-4" :disabled="autorization_send ? true:false" @click="mValidateForm">
                            Finalizar <font-awesome-icon icon="save" size="lg" />
                        </button>    
                    </div>
                </div>

            </div>

            <!-- end fourth tab -->
            <modal-other-charge :id-modal="modal_other_charge" :register="other_charge_register"></modal-other-charge>
            <modal-other-ship :id-modal="'addBoat'" :banderas="banderas"  :register="changeRegister" :view="changeBoats" :types_boat="types_boat"></modal-other-ship>
            <modal-loading :id-modal="modal_progress" :title="'Enviando'" :status-send="send_dispatch" ></modal-loading>
            <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
            <modal-append-person :id-modal="modal_person" :type-person="type_person"></modal-append-person>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
import modalOtherShip from './modalOtherShip';
import modalOtherCharge from './modalOtherCharge';
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';
import modalAppendPerson from './modalAppendPerson.vue'


export default {
    name:'b-n-register',
    mounted(){
        this.callBandera(),
        this.callNavigate(),
        this.callPropulsion(),
        this.callUfv(),
        // this.callLoadCash(),
        this.callPassenger(),
        this.callTypesShip(),
        this.getToday(),
        this.mCallBoats(),
        this.mCallPortsCaptain(),
        this.callFactorNavigate(),
        this.mChargeInit()
    },
    beforeDestroy(){
        console.log('se esta destruyendo el componente')
    },
    data(){
        return {
            type_person:'P',
            modal_person:'mod_pers',
            value_cabotaje:{
                days:0,
                description:null
            },
            is_cabotaje:false,
            value_days_cabotaje:{
                val:false,
                detail:'Emision para sindicato'
            },
            modal_other_charge:'charge_secondary',
            other_charge_register:true,
            capitan_ship:null,
            type_boat:null,
            types_boat:[],
            placeholder_port:'',
            port_query:'',
            portsRegister:[],
            question_add_ship:true,
            add_ship_form:false,
            autorization_send:true,
            send_dispatch:true,
            is_disabled:false,
            is_active_step_one:true,
            is_active_step_two:false,
            is_active_step_tree:false,
            is_active_step_fourth:false,
            date_office:null,
            date_office_aux:null,
            bandera:null,
            banderas:[],
            navegacion:null,
            navegaciones:[],
            navegacion_sub:[{factor:0}],//
            state_navigation_sub:false,
            navegaciones_sub:[],
            propulsion:[],//
            propulsiones:[],
            actividad:[],//
            actividades_nave:[],
            ufv:null,
            date_ufv:null,
            c_efectiva_passenger:false,
            c_efectiva_load_kilo:false,
            c_efectiva_load_litro:false,
            c_efectiva_load_rodada:false,
            c_quantity:0,
            passenger_view:false,
            load_cash_view:false,
            passenger:null,//
            load_cash_kilo:null,//
            load_cash_tonelada:null,
            load_cash_litro:null,//
            passengers:[],
            load_cashs:[],
            total_form:0,
            factor_trb:null,
            national_men:null,
            national_women:null,
            foreign_men:null,
            foreign_women:null,
            type_navigate:null,
            cut:0,
            type_ship:null,
            type_ships:[],
            register_boat:false,
            view_boats:false,
            port_begin:{
                id:null,
                description:null,
                disabled:false
            },
            port_finish:{
                id:null,
                description:null,
                disabled:false
            },
            ports_registers_captain:[],
            port_select_begin:{id:null, description:null},
            port_select_finish:{id:null, description:null},
            modal_progress:'sendDispatch',
            modal_report:'pdfZarpe',
            modal_rep_title:'Despacho de Nave',
            modal_rep_content:'',
            url_report:'pdfZarpe',
            id_reporte:0,
            load_query:null,
            loads_type:[],
            dPlaceLoad:"Carga",
            aux_activity:[],
            is_dredge:false,
            job_days:0,
            date_init_oper:null,
            date_end_oper:null,
            date_init_oper_aux:null,
            date_end_oper_aux:null,
            helpNavigate:{},
            auxHelpNavigate:{
                factor:0,
                import:0
            },
            type_load_liquid:[],
            type_load_solid:[],
            unit_measurement:[],
            description_charge:null,
            aux_unit_measurement:{id:0, detail:''},
            autImport:'N',
            mercancy_regime:[],
            aux_mercancy:''
        }
    },
    computed:{
        titleDispatch(){
            return this.$store.getters.getTitleDispatch;
        },
        cQuestionShip(){
            return this.question_add_ship;
        },
        cFormAddShip(){
            return this.add_ship_form;
        },
        global_disabled(){
            return this.$store.getters.getDisabled
        },
        boatLocal(){
            return this.$store.getters.getBoat
        },
        changeTrb(){
            return parseFloat(this.boatLocal.trb);
        },
        changeCUT(){
            return this.cut;
        },
        changeRegister(){
            return this.register_boat;
        },
        changeBoats(){
            return this.view_boats;
        },
        total_second(){

            return (parseFloat(this.$store.getters.getTotalDispatch)+parseFloat(this.total_form));

        },
        cCallShips(){
            return this.$store.getters.getShips;
        },
        cCallChargeSeconds(){
            return this.$store.getters['sChargesSecondary/getChargeSec'];
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
        cListPassenger(){
            return this.$store.getters['sListPersonDispatch/getListPersons']
        }
    },
    watch:{
        port_query(newQuery){
            
            // axios.get(`searchPort/${newQuery}`)
            axios.get(`searchPort/${newQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.portsRegister = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })             
        },
        load_query(newLoad){
            if(newLoad.length >= 3){
                // axios.get(`searchLoad/${newLoad}`)
                axios.get(`searchLoad/${newLoad}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {
                        
                        this.loads_type = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }
            
        }
    },
    methods:{
        mEditImport(t){
            let aux_imp=0;
            switch(t){
                case 'R':
                    console.log(`restamos el importe ${this.navegacion_sub.factor}`);
                    aux_imp=parseFloat(this.navegacion_sub.factor)-0.2;
                    if(aux_imp>0){
                        this.navegacion_sub.factor=aux_imp;
                        this.calculateForm();
                    }
                    break;
                
                case 'I':
                    console.log(`incrementamos el importe ${this.navegacion_sub.factor}`);
                    aux_imp=parseFloat(this.navegacion_sub.factor)+0.2;
                    if(aux_imp>0){
                        this.navegacion_sub.factor=aux_imp;
                        this.calculateForm();
                    }
                    break;
            }
        },
        async mChargeInit(){

        this.autImport=Vue.auth.getAutImp();

        let load_liquid= await axios.get(`globals/liquid?api_token=${Vue.auth.getToken()}`);
        let load_solid= await axios.get(`globals/solid?api_token=${Vue.auth.getToken()}`);
        let mercancy=await axios.get(`globals/mercancy?api_token=${Vue.auth.getToken()}`);

        let noOption={
                id:0,
                detail:'NINGUNO'
            };

            this.mercancy_regime=[];
            this.type_load_liquid=[];
            this.type_load_solid=[];
            this.type_load_liquid.push(noOption);
            this.type_load_solid.push(noOption);

            mercancy.data.forEach(v=>{
                let auxMercancy={
                    id:v.id,
                    detail:v.detail
                }
                this.mercancy_regime.push(auxMercancy);
            })

            load_liquid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_liquid.push(auxCharge);
            })

            load_solid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_solid.push(auxCharge);
            })
        },
        mModalShow(e){
            $(`#${e}`).modal('show');
        },
        callRegisterPerson(t){
            this.type_person=t;
            this.mModalShow(this.modal_person);
        },
        mChangeSindicate(){
            if(this.value_days_cabotaje.val){
                this.value_days_cabotaje.detail='Emision de solicitud para sindicato';
            }else{
                this.value_days_cabotaje.detail='Sin Emision de solicitud para sindicato por dias';
                this.value_cabotaje.days=0,
                this.value_cabotaje.description=null
                this.calculateForm();
            }            
                
            console.log('indicando que si se emitira por ser sindicato')
        },
        mSelectLoad(data){            
            
            this.type_ship=data.id_master;
            this.actividad.id=data.id;
            this.actividad.detail=data.detail;
            this.actividad.factor=data.factor;
            this.aux_activity.activity=data.master_detail;
            this.aux_activity.service=data.detail;
            this.viewForm(data.unit_measurement)
            this.calculateForm();
        },
        mSelectedPort(data){
            // console.log(data)

            if(!this.port_begin.disabled){
                this.port_select_begin.id=data.port;
                this.port_select_begin.description=data.portDetail;
            }

            if(!this.port_finish.disabled){
                this.port_select_finish.id=data.port;
                this.port_select_finish.description=data.portDetail;
            }

        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            this.date_office=today.getFullYear()+'-'+mes+'-'+dia;
            
        },
        mAddShip(event){
            switch(event.target.value){
                case 'no':
                    this.question_add_ship=false;
                    this.add_ship_form=false;
                    this.autorization_send=false;
                break;

                case 'si':
                    this.question_add_ship=false;
                    this.add_ship_form=true;
                    this.autorization_send=false;
                    this.callRegister();
                    $('#addBoat').modal('show');
                break;
            }
        },
        mAddCharge(event){
            switch(event.target.value){
                case 'no':
                    this.question_add_ship=false;
                    this.add_ship_form=false;
                    this.autorization_send=false;
                break;

                case 'si':
                    this.question_add_ship=false;
                    this.add_ship_form=true;
                    this.autorization_send=false;
                    this.callRegister();
                    $('#addBoat').modal('show');
                break;
            }
        },
        progressModal(){
            $('#'+this.modal_progress).modal('show');
        },
        closeProgressModal(){
            $('#'+this.modal_progress).modal('hide');
        },
        mShowModal(e){
            $('#'+e).modal('show');
        },
        mCloseModal(e){
            $('#'+e).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report).modal('show');
        },
        mUpdateShips(){            
            this.$store.dispatch('updateShip');
        },
        callRegisterCharge(){
            console.log('llamando a registro de cargas secundarias');
            this.other_charge_register=true;
            this.mShowModal(this.modal_other_charge);
        },
        callViewCharges(){
            console.log('llamando a lista de cargas secundarias');
            this.other_charge_register=false;
            this.mShowModal(this.modal_other_charge);
        },
        callRegister(){
            this.register_boat=true;
            this.view_boats=false;
        },
        callViewBoats(){
            
            this.register_boat=false;
            this.view_boats=true;
            this.mUpdateShips();
        },
        callTypesShip(){
            this.type_services=null;
            // axios.get('ships/servicionave?api_token='+Vue.auth.getToken())
            // axios.get(`ships/servicionave`)
            axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_ships=res.data
            })
        },
        codeToken(){
            return `${Math.random(0).toString(36).substr(2)}${Math.random(0).toString(36).substr(2)}${Math.random(0).toString(36).substr(2)}`;
        },
        mValidateForm(){
            let v=0;

            if( !(this.changeTrb > parseFloat(this.boatLocal.trn) ) ){
                v++
                toastr.error('El TRN NO puede ser mayor TRB', 'Error');
            }

            if( (this.port_select_begin.description ===null && this.port_begin.disabled) || ( this.port_begin.disabled===false && this.port_query==='') ){
                v++
                toastr.error('Debe indicar el puerto de origen', 'Error');
            }

            if(this.is_dredge){
                if( !(this.job_days>0) ){
                    toastr.error('Debe indicar los dias que efectuara el trabajo', 'Error');
                    v++;
                }

                let adi=this.date_init_oper_aux.split('T');
                this.date_init_oper=adi[0];

                if( this.date_init_oper === null || !(this.date_init_oper.length === 10) ){
                    toastr.error('La fecha de Inicio de Operacion es incorrecta', 'Error');
                    v++;
                }

                let ade=this.date_end_oper_aux.split('T');
                this.date_end_oper=ade[0];

                if( this.date_end_oper === null || !(this.date_end_oper.length === 10) ){
                    toastr.error('La fecha de Conclusion de Operacion es incorrecta', 'Error');
                    v++;
                }

            }
            // date_office y date_office_aux

            let dof=this.date_office.split('T');
                this.date_office_aux=dof[0];

            if( this.date_office_aux === null || !(this.date_office_aux.length === 10) ){
                toastr.error(`La fecha de ${this.type_navigate} es incorrecta`, 'Error');
                v++;
            }

            if( (this.port_select_finish.description === null && this.port_finish.disabled) || ( this.port_finish.disabled===false && this.port_query==='') ){
                v++
                toastr.error('DEBE INDICAR EL PUERTO DE DESTINO', 'Error');
            }

            if(this.aux_mercancy === null || this.aux_mercancy ===''){
                console.log(this.aux_mercancy.length);
                v++
                toastr.error('INDIQUE EL REGIMEN DE LA MERCANCIA');
            }

            if( v===0 ){
                this.sendRegister();
            }
        },
        sendRegister() {            
            
            // console.log(qs.stringify(param));
            if(this.total_form && this.boatLocal.name_boat && (this.boatLocal.enrollment || this.boatLocal.enrollment_old) && this.actividad.factor && this.capitan_ship ){
                let token=this.codeToken();
                let description_load_aux;
                let c_quantity_aux=this.c_quantity ? this.c_quantity:0;    
                if(this.c_efectiva_load_rodada){
                    
                    description_load_aux=this.load_query;
                }else{
                    description_load_aux=this.load_query ? this.load_query : '';
                }
                let shipMaster=[{
                    id_boat:this.boatLocal.id ? parseInt(this.boatLocal.id) : 0,
                    enrollment:this.boatLocal.enrollment ? this.boatLocal.enrollment: this.boatLocal.enrollment_old,
                    name_boat:this.boatLocal.name_boat,
                    trn:parseFloat(this.boatLocal.trn),
                    trb:parseFloat(this.boatLocal.trb),
                    detail_boat:this.boatLocal.detail_boat ? this.boatLocal.detail_boat:this.type_boat,
                    detail_propulsion:this.boatLocal.detail_propulsion ? this.boatLocal.detail_propulsion:this.propulsion.detail,
                    factor_propulsion:this.boatLocal.factor_propulsion ? parseFloat(this.boatLocal.factor_propulsion) : parseFloat(this.propulsion.factor),
                    factor_navigate:parseFloat(this.navegacion_sub.factor),
                    factor_activity:parseFloat(this.actividad.factor),
                    service:parseInt(this.actividad.id),
                    type_service:this.actividad.detail,
                    tarifa:parseFloat(this.total_form),
                    kilos:this.load_cash_kilo ? parseFloat(this.load_cash_kilo):0,
                    tonelada:this.load_cash_tonelada ? parseFloat(this.load_cash_tonelada):0,
                    litros:this.load_cash_litro ? parseFloat(this.load_cash_litro):0,
                    national_man:this.national_men ? parseInt(this.national_men):0,
                    national_woman:this.national_women ? parseInt(this.national_women):0,
                    foreign_man:this.foreign_men ? parseInt(this.foreign_men):0,
                    foreign_woman:this.foreign_women ? parseInt(this.foreign_women):0,                
                    description_load:description_load_aux,
                    flag:this.boatLocal.flag ? parseInt(this.boatLocal.flag) : parseInt(this.bandera.id),
                    flag_boat:this.boatLocal.flag_boat ? this.boatLocal.flag_boat:this.bandera.detail,
                    type:'p',
                    factor_snh:this.auxHelpNavigate.factor,
                    import_snh:this.auxHelpNavigate.import,
                    quantity:c_quantity_aux,
                    unit_id_quantity:this.aux_unit_measurement.id,
                    unit_quantity:this.aux_unit_measurement.detail,
                    quantity_description:this.description_charge
                }]
                
                for(let key in this.cCallShips){
                    shipMaster.push(this.cCallShips[key]);
                }



                let chargeSeconds=[];
                if(this.cCallChargeSeconds.length > 0){
                    for(let key in this.cCallChargeSeconds){
                        chargeSeconds.push(this.cCallChargeSeconds[key]);
                    }
                }
                
                
                const headMast={                    
                    dispatch_t:this.navegacion.detail,
                    operation:parseInt(this.navegacion_sub.id),
                    type_operation:this.navegacion_sub.detail,
                    capitan_port:'',
                    capitan_id:0,
                    capitan_ship:this.capitan_ship,
                    port_begin:this.port_begin.disabled ? this.port_select_begin.id:0,
                    port_begin_des:this.port_begin.disabled ? this.port_select_begin.description:this.port_query,
                    port_finish:this.port_finish.disabled ? this.port_select_finish.id:0,
                    port_finish_des:this.port_finish.disabled ? this.port_select_finish.description:this.port_query,
                    location:0,
                    location_des:'',
                    date_operation:this.date_office_aux,
                    job_days:this.job_days,
                    date_init_oper:this.date_init_oper,
                    date_end_oper:this.date_end_oper,
                    token_s: token,
                    ufv:this.ufv,
                    is_sindicate:this.is_cabotaje ? 'S' : 'N',
                    days_sindicate:this.value_cabotaje.days > 0 ? this.value_cabotaje.days:0,
                    sindicate:this.value_cabotaje.description !==null ? this.value_cabotaje.description:'S/D',
                    mercancy_regime:this.aux_mercancy         
                }

                let listPerson=this.cListPassenger;

                let param={
                    headDispatch:JSON.stringify(headMast),
                    bodyDispatch:JSON.stringify(shipMaster),
                    chargeSecond:JSON.stringify(chargeSeconds),
                    listPersons:JSON.stringify(listPerson)
                }
                console.log(param);
            let message = {
                title: `Solicitud de Despacho de Nave`,
                body: `¿Desea registrar el despacho de la Nave o Artefacto Naval ?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then((msg) =>{
                if(msg){
                    this.progressModal();
                
                    // axios.post(`insertDispatch`, 
                    axios.post(`insertDispatch?api_token=${Vue.auth.getToken()}`, 
                                    qs.stringify(param))
                        .then(res=>{
                            //#hacer 
                            
                            setTimeout(()=>{
                                this.closeProgressModal();
                                this.modal_rep_content=res.data[0].respuesta;
                                this.id_reporte=res.data[1].id_rep;
                                if(this.id_reporte!==0){
                                    this.add_ship_form=false;
                                    this.autorization_send=false;   
                                    this.is_active_step_fourth=false;
                                    this.is_active_step_tree=false;
                                    this.is_active_step_two=false;
                                    this.is_active_step_one=true;
                                    this.autorization_send=true;
                                    this.question_add_ship=true;
                                    this.c_efectiva_passenger=false;
                                    this.c_efectiva_load_kilo=false;
                                    this.c_efectiva_load_litro=false;
                                    this.c_efectiva_load_rodada=false;

                                    this.c_quantity=0;
                                    this.$store.dispatch('deleteBoat',true);
                                    this.$store.dispatch('changeDisabled',false);
                                    this.$store.dispatch('refreshShip',true);
                                    this.$store.dispatch('deleteDregde', true);
                                    this.$store.dispatch('sChargesSecondary/deleteChargeClear', true);
                                    this.$store.dispatch('sListPersonDispatch/deletePersonAll', true);
                                }
                                // this.mResetForm();                  
                                this.mModalReportShow();
                            }, 2000);
                            
                        }).catch(error => {
                        setTimeout(()=>{
                            this.closeProgressModal();
                            console.log(error);
                            toastr.error('Verifique que su session aun este vigente','Error');
                        }, 3000);
                        console.log(error)
                    })
                    }else{
                        console.log('se ha rechazado la baja del personal')
                    }
                })                
            }else{
                toastr.warning('Verifique que los campos esten completos ','Advertencia');
            }
        },
        mResetForm(){
            this.port_select_begin.id=null;
            this.port_select_begin.description=null;
            this.port_select_finish.id=null;
            this.port_select_finish.description=null;
            this.port_query='';
        },
        calcCUT(){
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            let fact_d=2.3;
            this.cut=fact_c/(fact_d*(1+fact_a*Math.pow(this.changeTrb, (1/fact_b) )));
        },
        callBandera(){
            // axios.get(`flags`)
            axios.get(`flags?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.banderas=res.data
            })
        },
        mCallBoats(){
            // axios.get(`boats`)
            axios.get(`boats?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_boat=res.data
            })
        },
        async mCallPortsCaptain(){
            // let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}`);
            let cr=await axios.get(`portsCaptain/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
            this.ports_registers_captain=[];
            // console.log(cr);
            let ar=cr.data;
            ar.forEach( (e,index) => {
                let ap={
                    id:e.id,
                    description:e.description,
                    code_aux:index
                }
                this.ports_registers_captain.push(ap);
            });            
        },
        callNavigate(){
            // axios.get('navigation')
            axios.get(`navigation?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                
                this.navegaciones=res.data
            })
        },
        callPropulsion(){
            let propulsion={
                parent:4
            }
            // axios.post('submenu', qs.stringify(propulsion))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion))
            .then(res => {                
                this.propulsiones=res.data
            })
        },
        callService(){
            // axios.get('submenus/'+this.type_ship)
            axios.get(`submenus/${this.type_ship}?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.actividades_nave=res.data
            })
        },
        callUfv(){
            // axios.get('ufv?api_token='+Vue.auth.getToken())
            // axios.get(`ufv`)
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                // console.log(res.data[0])
                this.ufv=res.data[0].value;
                this.date_ufv=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                this.calculateForm();
                // this.mUpdateShips();
            })
        },
        callFactorNavigate(){
            let propulsion={
                parent:16
            }
            // axios.post('submenu', qs.stringify(propulsion))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion))
            .then(res => {                
                this.helpNavigate=res.data[0]
                // console.log(this.helpNavigate)
            })
        },
        callNavDet(){
            
                this.findValue(this.navegacion.id);
                // axios.post('submenu',qs.stringify({parent:this.navegacion.id}))
                let sendNavigate={
                    parent:this.navegacion.id,
                    captain:this.cDtsUser.portId,
                    type:'E'
                }
                axios.post(`submenu?api_token=${Vue.auth.getToken()}`,qs.stringify(sendNavigate))
                .then(res => {                
                    this.navegaciones_sub=res.data
                    this.state_navigation_sub=true
                })
            
        },
        findValue(id){
            // for(let i=0; i<this.navegaciones.length; i++){
            //     this.navegaciones
            // }
            for(let key in this.navegaciones){
                if(this.navegaciones[key].id === id){
                    this.type_navigate=this.navegaciones[key].detail.toLowerCase();                    
                }
            }

            switch(this.type_navigate){
                case 'zarpe':
                    // this.port_begin.id=this.cDtsUser.portId;
                    // this.port_begin.description=this.cDtsUser.name_port;
                    this.port_begin.disabled=true;

                    // this.port_select_finish.id=null;
                    // this.port_select_finish.description=null;
                    
                    this.placeholder_port='PUERTO ATRAQUE';
                    
                    this.port_finish.id=null;
                    this.port_finish.description=null;
                    this.port_finish.disabled=false;
                break;

                case 'atraque':
                    // this.port_finish.id=this.cDtsUser.portId;
                    // this.port_finish.description=this.cDtsUser.name_port;
                    this.port_finish.disabled=true;

                    this.placeholder_port='PUERTO ZARPE';

                    // this.port_select_begin.id=null;
                    // this.port_select_begin.description=null;

                    this.port_begin.id=null;
                    this.port_begin.description=null;
                    this.port_begin.disabled=false;
                break;
            }
        },
        callPassenger(){
            // axios.post(`submenu`,qs.stringify({parent:5}))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`,qs.stringify({parent:5}))
            .then(res => {                
                this.passengers=res.data
            })
        },
        viewForm(data){
            console.log(`el valor es ${data}`);
            switch(data){
                case 'C':
                    this.c_efectiva_passenger=false;
                    this.c_efectiva_load_kilo=true;
                    this.c_efectiva_load_litro=false;
                    this.c_efectiva_load_rodada=false;
                break;
                case 'L':
                    this.c_efectiva_passenger=false;
                    this.c_efectiva_load_kilo=false;
                    this.c_efectiva_load_litro=true;
                    this.c_efectiva_load_rodada=false;
                break;
                case 'P':
                    this.c_efectiva_passenger=true;
                    this.c_efectiva_load_kilo=false;
                    this.c_efectiva_load_litro=false;
                    this.c_efectiva_load_rodada=false;
                break;
                case 'R':
                    this.c_efectiva_passenger=false;
                    this.c_efectiva_load_rodada=true;
                    this.c_efectiva_load_kilo=false;
                    this.c_efectiva_load_litro=false;
                break;
            }
            
        },
        calculateForm(){
            // console.log(this.navegacion_sub);
            if(this.navegacion_sub.allow_description === 'S'){
                this.is_cabotaje=true;
            }else{
                this.is_cabotaje=false;
                this.value_cabotaje.days=0;
                this.value_cabotaje.description=null;
                this.value_days_cabotaje.val=false;
            }
            
            let factors={
                    navigate:this.navegacion_sub.factor,
                    activity:this.actividad.factor
            }
            this.$store.dispatch('addFactor', factors);
            this.$store.dispatch('addHelpNavigation', this.helpNavigate.factor);
            let result=0;
            this.calcCUT();       
            // console.log(this.propulsion);
            // console.log(this.boatLocal);
            // console.log(this.actividad);
            // console.log(this.navegacion_sub);

            if( (this.propulsion.detail === 'SIN PROPULSION PROPIA' || this.boatLocal.detail_propulsion === 'SIN PROPULSION PROPIA') && this.actividad.detail === 'EXTRACCION MINERAL' && this.navegacion_sub.detail === 'LOCAL FIJO' ){
                this.is_dredge=true;

                // console.log('entramos al de operaciones de dragado');
                this.auxHelpNavigate.factor=0;
                this.auxHelpNavigate.import=0;

                if(this.job_days > 0){
                    let factors={
                        job_days:this.job_days,
                        is_dredge:this.is_dredge
                    }
                    this.$store.dispatch('addDredge', factors);

                    if(this.navegacion_sub && (this.propulsion || this.boatLocal.factor_propulsion) && this.actividad.factor && this.changeCUT){
                        
                        let factPropulsion;
                        // result = (1+this.navegacion_sub.factor*this.propulsion.factor*actividad_pasajeros*this.factor_trb)*this.ufv;
                        factPropulsion= this.boatLocal.factor_propulsion ? this.boatLocal.factor_propulsion : this.propulsion.factor;
                        result= (this.changeCUT*this.boatLocal.trb*(this.navegacion_sub.factor*factPropulsion*this.actividad.factor)*this.job_days)*this.ufv;

                        let aux_result=result.toFixed(2);
                    
                        let number_enter=Math.trunc(aux_result);
                        let number_decimal=Number((aux_result-number_enter).toFixed(2));

                        if(number_decimal===0.50){
                            result=aux_result;
                    
                        }else if(number_decimal>0.50){
                            result=number_enter+1;
                    
                        }else{                
                            result=number_enter;
                    
                        }

                        this.total_form=result;
                        this.mUpdateShips();
                        // toastr.success(''+this.total_form+'','Importe Aprox.')
                    }else{
                        console.log('aun faltan datos por confirmar en modo dragado');
                        // toastr.error('Aun falta llenar campos', 'Alerta');
                    }
                }else{
                    toastr.warning('Debe Indicar el numero de dias de trabajo','Advertencia');
                }

            }else{
                // aqui colocamos para sindicato

                this.is_dredge=false;
                this.job_days=0;

                let factors={
                    job_days:this.job_days,
                    is_dredge:this.is_dredge
                }
                
                // aqui mandamos al storage si es para sindicato y los dias

                this.$store.dispatch('addDredge', factors);

                console.log('entramos al normal de zarpe y atraque');
                if(this.navegacion_sub && (this.propulsion || this.boatLocal.factor_propulsion) && this.actividad.factor && this.changeCUT){
                    
                let factPropulsion;
                    // result = (1+this.navegacion_sub.factor*this.propulsion.factor*actividad_pasajeros*this.factor_trb)*this.ufv;
                factPropulsion= this.boatLocal.factor_propulsion ? this.boatLocal.factor_propulsion : this.propulsion.factor;
                result= ((this.changeCUT*this.boatLocal.trb*(this.navegacion_sub.factor*factPropulsion*this.actividad.factor)+1)*this.ufv)*this.helpNavigate.factor;

                if(this.is_cabotaje){
                    this.$store.dispatch('addIsSindicate', 'S');
                    // si es cabotaje se debe multiplicar por los dias solicitados
                    if(this.value_cabotaje.days > 0){
                        this.$store.dispatch('addDaysSindicate', parseInt(this.value_cabotaje.days));
                        let aux_days_cabotaje=result*parseInt(this.value_cabotaje.days);
                        result=aux_days_cabotaje;
                    }else{
                        this.$store.dispatch('addDaysSindicate', parseInt(0));
                        toastr.warning('Indique el numero de dias a solicitar el cabotaje');
                    }
                }else{
                    this.$store.dispatch('addIsSindicate', 'N');
                }

                let aux_result=result.toFixed(2);

                let number_enter=Math.trunc(aux_result);
                let number_decimal=Number((aux_result-number_enter).toFixed(2));

                if(number_decimal===0.50){
                    result=aux_result;
                

                }else if(number_decimal>0.50){
                    result=number_enter+1;
                
                }else{                
                    result=number_enter;                
                }
                    
                this.auxHelpNavigate.factor=this.helpNavigate.factor;
                this.auxHelpNavigate.import=(result-(result/parseFloat(this.helpNavigate.factor))).toFixed(1);
                    // console.log(`el importe del factor AN es: ${this.auxHelpNavigate.import}`);

                this.mUpdateShips();

                

                this.total_form=result;
                    // toastr.success(''+this.total_form+'','Importe Aprox.')
                }else{
                    console.log('aun faltan datos por confirmar en modo normal');
                    // toastr.error('Aun falta llenar campos', 'Alerta');
                }
            }
            
        },
        fNext(){
            switch(true){
                case this.is_active_step_one:
                    this.is_active_step_one=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_tree=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_fourth=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_one=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_fourth:
                    this.is_active_step_fourth=false;
                    this.is_active_step_tree=true;
                break;
            }
        },
        calcToneladaKilo(){
            this.load_cash_kilo=this.load_cash_tonelada*1000;
        },
        calcKiloTonelada(){
            this.load_cash_tonelada=this.load_cash_kilo/1000;
        }
    },
    components:{
        'modal-other-ship':modalOtherShip,
        'modal-loading':modalLoading,
        'modal-report':modalReport,
        'modal-other-charge':modalOtherCharge,
        'modal-append-person':modalAppendPerson
    }
}
</script>




// WEBPACK FOOTER //
// src/components/cotizacion/boatNotRegister.vue